import React, { useContext } from 'react';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import NoFiltersChangePosition from 'components/NoFiltersChangePosition/NoFiltersChangePosition';
import ChangePositionControlPanel from './components/ChangePositionControlPanel/ChangePositionControlPanel';
import ChangePositionList from './components/ChangePositionList/ChangePositionList';
import ModalWindows from './components/ModalWindows/ModalWindows';
import BtnBlock from './components/BtnBlock';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	ChangeModifierPositionContext,
	IChangeModifierPositionContext,
} from '../../changeModifierPositionState/changeModifierPositionContext';
import style from './ChangeModifierPosition.module.scss';

const ChangeModifierPosition: React.FC = () => {
	const { positionsData, IDSelectedModifierGroup } =
		useContext<IChangeModifierPositionContext>(ChangeModifierPositionContext);
	const { isLoading } = useContext<IAppContext>(AppContext);

	return (
		<div className={style.container} data-test="ChangeModifierPosition">
			<ChangePositionControlPanel />
			{positionsData?.length ? (
				<>
					<ChangePositionList />
					<BtnBlock />
					<ModalWindows />
				</>
			) : (
				<NoResultsFound isVisible={!isLoading && !!IDSelectedModifierGroup} />
			)}
			<NoFiltersChangePosition isVisible={!IDSelectedModifierGroup} />
		</div>
	);
};

export default ChangeModifierPosition;
